module.exports = __webpack_public_path__ + "media/images/emblems/Tamins_wappen-a772e067c32fab58bdf496bd5c0769a2.svg";